import { Module } from 'vuex-smart-module';
import AlfaApiLoanApplicationsActions from './actions';
import AlfaApiLoanApplicationsGetters from './getters';
import AlfaApiLoanApplicationsMutations from './mutations';
import AlfaApiLoanApplicationsState from './state';

export default new Module({
  state: AlfaApiLoanApplicationsState,
  mutations: AlfaApiLoanApplicationsMutations,
  actions: AlfaApiLoanApplicationsActions,
  getters: AlfaApiLoanApplicationsGetters,
});
